import React from "react"
import { FormattedNumber } from "react-intl"
import { useGlobalStore, useOrderStore } from "../../../store/hooks/useStore"
import { Box, Stack, Text } from "../../../vanilla"
import { SavedPaymentMethodAccordion } from "./saved-payment-method-accordion"
import { PaymentMethodAccordion } from "./payment-method-accordion"
import { PaymentOptionsProps } from "../../../types/checkout"

export const PaymentOptions = (props: PaymentOptionsProps) => {
  const { currency } = useGlobalStore()
  const { orderTotalWithoutBC } = useOrderStore()
  const {
    bonusCardStatus,
    userVaultedCards,
    paymentMethods,
    savedCardEnabled,
    selectedPayment,
    braintreeFormIsValid,
    hostedFieldsErrors,
    setSelectedPayment,
    submitOrderProcess,
    isTopUp,
    allowSaveCreditCard,
    braintreeInputs,
    hostedFieldsValidationErrors,
    inputRefs,
    setSaveCreditCard,
    usingSavedCard,
    fullBCPayment
  } = props
  return (
    <Box
      padding="16px"
      width={'full'}
    >
      <Stack>
        {bonusCardStatus?.bonusCardUsed && (
          <Stack direction="row">
            <Text variant="text6">Amount left to pay:</Text>
            <Text color="accent3" variant="text6" data-test-selector="amount-left-to-pay-value">
              <FormattedNumber
                style="currency"
                currency={currency}
                value={orderTotalWithoutBC}
              />
            </Text>
          </Stack>
        )}

        <Stack justifyContent="space-between" direction="column" flexWrap="wrap">
          {savedCardEnabled &&
            userVaultedCards?.map((card) => (
              <SavedPaymentMethodAccordion
                card={card}
                selectedPayment={selectedPayment}
                braintreeFormIsValid={braintreeFormIsValid}
                hostedFieldsErrors={hostedFieldsErrors}
                setSelectedPayment={setSelectedPayment}
                submitOrderProcess={submitOrderProcess}
                isTopUp={isTopUp}
              />
            ))}

          {paymentMethods?.map((paymentMethod) =>
            <PaymentMethodAccordion
              selectedPayment={selectedPayment}
              setSelectedPayment={setSelectedPayment}
              paymentMethod={paymentMethod}
              bonusCardStatus={bonusCardStatus}
              submitOrderProcess={submitOrderProcess}
              allowSaveCreditCard={allowSaveCreditCard}
              braintreeFormIsValid={braintreeFormIsValid}
              braintreeInputs={braintreeInputs}
              hostedFieldsErrors={hostedFieldsErrors}
              hostedFieldsValidationErrors={hostedFieldsValidationErrors}
              inputRefs={inputRefs}
              savedCardEnabled={savedCardEnabled}
              setSaveCreditCard={setSaveCreditCard}
              usingSavedCard={usingSavedCard}
              isTopUp={isTopUp}
              fullBCPayment={fullBCPayment}
            />
          )}
        </Stack>
      </Stack>
    </Box>
  )
}